/* ============================================================
   Meidi Logo Fees v2
   Sincronizeaza automat taxele de personalizare cu logo:
   - "Personalizare logo (taxa per bucata)"  -> cantitate = suma bucatilor cu logo din cos
   - "Taxa stanta logo (plata unica)"        -> 1 per logo nou (sarita daca clientul are deja stanta)
   Sursa de adevar: liniile din cos care au proprietatea "Logo personalizat".
   Fisier izolat - nu depinde de theme.js. Config: window.MeidiFees (din snippets/meidi-logo-fees.liquid).

   v2 - corectii fata de v1:
   1. refreshCartUI NU mai inlocuieste elementul sectiunii quick-cart (replaceChild
      omora listener-ele delegate ale temei Stiletto -> cos blocat pana la refresh).
      Acum se actualizeaza doar continutul interior, elementele-radacina raman aceleasi.
   2. Pe pagina /cart nu se mai face location.reload() - sectiunea se redeseneaza AJAX.
   3. Coada FIFO unica pentru toate operatiunile pe cos (citirile si mutatiile temei +
      sincronizarile proprii) -> elimina race-ul pe numerele de linie din /cart/change.js.
   4. decorate() scrie in DOM doar cand textul chiar difera -> fara bucla infinita
      MutationObserver <-> decorate.
   5. Bulina din header ([data-js-cart-count]) numara doar produsele REALE (fara taxe).
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.MeidiFees;
  if (!CFG || !CFG.feeVariantId || !CFG.stantaVariantId) return;

  var LOGO_PROP = 'Logo personalizat';   // proprietate existenta, setata de sections/meidi-logo-upload.liquid
  var SKIP_PROP = 'Stanta existenta';    // "Da" = clientul are deja stanta pentru acest logo
  var MARK = 'meidi_fee=1';              // marcheaza request-urile proprii ca sa nu se auto-intercepteze

  function isOwn(url) { return url && url.indexOf(MARK) !== -1; }
  function isFeeVariant(id) { return id === CFG.feeVariantId || id === CFG.stantaVariantId; }

  /* ---------- coada FIFO pentru operatiuni pe cos ----------
     Serializeaza: GET /cart.js al temei, mutatiile temei si sincronizarile proprii.
     Astfel tema nu mai citeste un snapshot de cos pe care sync-ul il modifica in paralel
     (race pe numerele de linie). Cererile proprii (marcate MARK) NU trec prin coada,
     ca sa nu se blocheze singure cand ruleaza din interiorul unui task. */
  var queueTail = Promise.resolve();
  function enqueue(task) {
    var run = queueTail.then(task, task);
    // coada merge mai departe indiferent de rezultat; plasa de siguranta 10s
    // in caz ca un request ramane agatat (nu afecteaza promisiunea intoarsa apelantului)
    var settled = run.then(function () {}, function () {});
    queueTail = Promise.race([
      settled,
      new Promise(function (resolve) { setTimeout(resolve, 10000); })
    ]);
    return run;
  }

  /* ---------- citire cos + calcul tinte ---------- */

  function getCart() {
    return fetch('/cart.js?' + MARK, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function computeTargets(cart) {
    var feeQty = 0;
    var logos = {}; // url logo -> are nevoie de stanta?
    (cart.items || []).forEach(function (item) {
      if (isFeeVariant(item.variant_id)) return;
      var p = item.properties || {};
      var logo = p[LOGO_PROP];
      if (!logo) return;
      feeQty += item.quantity;
      if (!(logo in logos)) logos[logo] = true;
      if (p[SKIP_PROP] === 'Da') logos[logo] = false;
    });
    var stantaQty = 0;
    for (var k in logos) { if (logos[k]) stantaQty++; }
    return { feeQty: feeQty, stantaQty: stantaQty };
  }

  function findLine(cart, variantId) {
    for (var i = 0; i < (cart.items || []).length; i++) {
      if (cart.items[i].variant_id === variantId) return cart.items[i];
    }
    return null;
  }

  /* numar de produse REALE (fara liniile de taxa) - pentru bulina din header */
  function realItemCount(cart) {
    var total = cart.item_count || 0;
    (cart.items || []).forEach(function (item) {
      if (isFeeVariant(item.variant_id)) total -= item.quantity;
    });
    return total < 0 ? 0 : total;
  }

  function updateCartBadge(cart) {
    var badges = document.querySelectorAll('[data-js-cart-count]');
    for (var i = 0; i < badges.length; i++) setText(badges[i], String(realItemCount(cart)));
  }

  /* ---------- mutatii ---------- */

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function setLine(cart, variantId, targetQty) {
    var line = findLine(cart, variantId);
    var current = line ? line.quantity : 0;
    if (current === targetQty) return Promise.resolve(false);
    var req = line
      ? postJSON('/cart/change.js?' + MARK, { id: line.key, quantity: targetQty })
      : postJSON('/cart/add.js?' + MARK, { items: [{ id: variantId, quantity: targetQty }] });
    return req.then(function () { return true; });
  }

  /* ---------- sincronizare ---------- */

  function doSync() {
    return getCart()
      .then(function (cart) {
        var t = computeTargets(cart);
        return setLine(cart, CFG.feeVariantId, t.feeQty).then(function (c1) {
          return setLine(cart, CFG.stantaVariantId, t.stantaQty).then(function (c2) {
            return c1 || c2;
          });
        });
      })
      .catch(function (err) {
        console.error('[Meidi Fees] Eroare sincronizare:', err);
        return false;
      });
  }

  /* sincronizare programata prin coada + reimprospatare UI daca s-a schimbat ceva */
  function scheduleSync() {
    enqueue(doSync).then(function (changed) { if (changed) refreshCartUI(); });
  }

  /* ---------- reimprospatare UI dupa corectii post-hoc ----------
     IMPORTANT: nu se inlocuieste niciodata elementul sectiunii in sine -
     tema Stiletto isi tine listener-ele (delegate) si referintele pe el.
     Se rescrie doar continutul interior, exact ca redesenarile proprii ale temei. */

  function swapInner(selector, freshRoot, targetRoot) {
    var target = targetRoot.querySelector(selector);
    var fresh = freshRoot.querySelector(selector);
    if (target && fresh && target.innerHTML !== fresh.innerHTML) target.innerHTML = fresh.innerHTML;
  }

  function refreshSection(sectionSelector, route, applyFn) {
    try {
      var current = document.querySelector(sectionSelector);
      var wrap = current && current.closest('[id^="shopify-section-"]');
      if (!wrap) return;
      var sectionId = wrap.id.replace('shopify-section-', '');
      fetch(route + '?section_id=' + encodeURIComponent(sectionId))
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector(sectionSelector);
          var target = document.querySelector(sectionSelector);
          if (fresh && target) applyFn(fresh, target);
        })
        .catch(function () {});
    } catch (e) {}
  }

  function refreshCartUI() {
    // bulina cu numarul de produse de pe iconita cosului din header
    // (tema o actualizeaza doar prin evenimentele ei interne, pe care corectiile
    // noastre le ocolesc - deci o aducem la zi manual, numarand doar produsele reale)
    getCart().then(updateCartBadge).catch(function () {});

    // pagina de cos (daca suntem pe ea): redesenare AJAX, fara reload
    if (location.pathname.indexOf('/cart') === 0) {
      refreshSection('[data-section-type="cart"]', location.pathname, function (fresh, target) {
        target.innerHTML = fresh.innerHTML; // acelasi lucru il face si tema pe ramura "cos gol"
      });
    }
    // cosul rapid (drawer) - exista pe toate paginile
    refreshSection('[data-section-type="quick-cart"]', '/', function (fresh, target) {
      var freshForm = fresh.querySelector('.quick-cart__form');
      var targetForm = target.querySelector('.quick-cart__form');
      if (freshForm && targetForm) {
        // ambele au produse: actualizam aceleasi zone pe care le actualizeaza si tema
        swapInner('.quick-cart__items', fresh, target);
        swapInner('.quick-cart__heading', fresh, target);
        swapInner('.quick-cart__footer-inner', fresh, target);
      } else {
        // tranzitie plin <-> gol: rescriem continutul containerului
        // (.quick-cart__wrapper si .quick-cart__container raman aceleasi noduri)
        swapInner('.quick-cart__container', fresh, target);
      }
    });
  }

  /* ---------- detectie logo in body-ul unui /cart/add ---------- */

  function addBodyHasLogo(body) {
    try {
      if (!body) return false;
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var v = body.get('properties[' + LOGO_PROP + ']');
        return !!(v && String(v).length > 5);
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        var u = body.get('properties[' + LOGO_PROP + ']');
        return !!(u && String(u).length > 5);
      }
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          var j = JSON.parse(body);
          var items = j.items || [j];
          return items.some(function (it) {
            return it && it.properties && it.properties[LOGO_PROP] && String(it.properties[LOGO_PROP]).length > 5;
          });
        }
        var decoded = decodeURIComponent(body.replace(/\+/g, ' '));
        var m = decoded.match(/properties\[Logo personalizat\]=([^&]+)/);
        return !!(m && m[1] && m[1].length > 5);
      }
    } catch (e) {}
    return false;
  }

  /* ---------- interceptor fetch ---------- */

  var _fetch = window.fetch;
  window.fetch = function (resource, init) {
    var args = arguments;
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';

    if (isOwn(url)) return _fetch.apply(window, args);

    var isCartMutation = /\/cart\/(add|change|update|clear)/.test(url);
    var isCartRead = /\/cart\.js/.test(url);

    if (!isCartMutation && !isCartRead) return _fetch.apply(window, args);

    if (isCartRead) {
      // serializam si citirile de cos ale temei: snapshot-ul de linii e mereu actual
      return enqueue(function () { return _fetch.apply(window, args); });
    }

    var isAdd = /\/cart\/add/.test(url);
    var hasLogo = isAdd && init && addBodyHasLogo(init.body);

    return enqueue(function () {
      return _fetch.apply(window, args).then(function (response) {
        if (!response.ok) return response;

        if (hasLogo) {
          // Adaugare produs cu logo: taxele intra in cos INAINTE ca tema sa redeseneze cosul.
          return doSync().then(function () { return response; }, function () { return response; });
        }

        // Alte modificari (cantitati, stergeri): corectam dupa, apoi reimprospatam afisarea.
        scheduleSync();
        return response;
      });
    });
  };

  /* ---------- interceptor XHR (fallback pentru scripturi terte) ---------- */

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._meidiFeeUrl = url;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var u = this._meidiFeeUrl || '';
    if (/\/cart\/(add|change|update|clear)/.test(u) && !isOwn(u)) {
      this.addEventListener('load', function () { scheduleSync(); });
    }
    return _send.apply(this, arguments);
  };

  /* ---------- verificare la incarcarea paginii de cos ---------- */

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    if (location.pathname.indexOf('/cart') === 0) scheduleSync();
  });

  /* ---------- etichete explicative pe liniile de taxa din cos ---------- */

  var lastCart = null;
  var lastCartAt = 0;

  function feeNote(variantId, qty) {
    if (variantId === CFG.feeVariantId) {
      return 'Cantitate: ' + qty + ' buc × ' + (CFG.feePriceFormatted || '') +
        ' — se actualizează automat după produsele cu logo';
    }
    return 'Plată unică pentru schița logo-ului — nu se mai achită la comenzile următoare';
  }

  function formatMoney(cents) {
    var template = CFG.feePriceFormatted || '0,00 lei';
    var amount;
    try {
      amount = new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      amount = (cents / 100).toFixed(2).replace('.', ',');
    }
    return template.replace(/[\d.,]+/, amount);
  }

  /* scrie in DOM doar daca textul chiar difera - previne bucla MutationObserver <-> decorate */
  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  /* Iconite desenate inline (SVG) - nu depind de imaginile produselor */
  var ICON_STANTA = 'data:image/svg+xml;utf8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">' +
    '<rect width="96" height="96" rx="14" fill="%23faf8f5"/>'.replace(/%23/g, '#') +
    '<rect x="40" y="16" width="16" height="12" rx="5" fill="#96754a"/>' +
    '<path d="M36 28h24l8 20H28z" fill="#b8935a"/>' +
    '<rect x="22" y="48" width="52" height="12" rx="5" fill="#96754a"/>' +
    '<rect x="28" y="68" width="40" height="5" rx="2.5" fill="#e5ddd4"/>' +
    '<rect x="34" y="78" width="28" height="5" rx="2.5" fill="#e5ddd4"/>' +
    '</svg>'
  );
  var ICON_LOGO = 'data:image/svg+xml;utf8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">' +
    '<rect width="96" height="96" rx="14" fill="#faf8f5"/>' +
    '<rect x="26" y="26" width="44" height="44" rx="9" fill="#b8935a" transform="rotate(45 48 48)"/>' +
    '<circle cx="48" cy="30" r="5" fill="#fff"/>' +
    '<text x="48" y="55" font-family="Arial,Helvetica,sans-serif" font-size="14" font-weight="bold" fill="#fff" text-anchor="middle">LOGO</text>' +
    '</svg>'
  );

  function setIcon(el, vid) {
    var box = el.querySelector('.quick-cart__item-image, .cart__form-item-image');
    if (!box || box.dataset.meidiIcon) return;
    box.dataset.meidiIcon = '1';
    var img = document.createElement('img');
    img.src = vid === CFG.stantaVariantId ? ICON_STANTA : ICON_LOGO;
    img.alt = vid === CFG.stantaVariantId ? 'Taxă ștanță logo' : 'Personalizare logo';
    img.style.cssText = 'width:100%;height:auto;border-radius:8px;display:block;';
    box.innerHTML = '';
    box.appendChild(img);
  }

  function decorate(cart) {
    var byVariant = {};
    (cart.items || []).forEach(function (it) { byVariant[it.variant_id] = it; });
    [CFG.feeVariantId, CFG.stantaVariantId].forEach(function (vid) {
      var item = byVariant[vid];
      var els = document.querySelectorAll('[data-input-item][data-id="' + vid + '"]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        setIcon(el, vid);
        var note = el.querySelector('.meidi-fee-note');
        if (!note) {
          note = document.createElement('p');
          note.className = 'meidi-fee-note';
          note.style.cssText = 'font-size:11.5px;color:#8a7c6e;margin:4px 0 0;line-height:1.45;';
          var anchor = el.querySelector('.quick-cart__item-title, .cart__form-item-title');
          if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(note, anchor.nextSibling);
          else el.appendChild(note);
        }
        setText(note, feeNote(vid, item ? item.quantity : 0));
        /* Pretul afisat pe linie = totalul liniei (cantitate x pret unitar) */
        if (item) {
          var price = el.querySelector('.quick-cart__item-price, .cart__form-item-price');
          if (price) setText(price, formatMoney(item.final_line_price != null ? item.final_line_price : item.line_price));
        }
      }
    });
  }

  var decoTimer = null;
  function scheduleDecorate() {
    if (decoTimer) clearTimeout(decoTimer);
    decoTimer = setTimeout(function () {
      decoTimer = null;
      var hasFeeLines = document.querySelector(
        '[data-input-item][data-id="' + CFG.feeVariantId + '"], [data-input-item][data-id="' + CFG.stantaVariantId + '"]'
      );
      if (!hasFeeLines) return;
      var now = Date.now();
      if (lastCart && now - lastCartAt < 4000) { decorate(lastCart); updateCartBadge(lastCart); return; }
      getCart().then(function (cart) {
        lastCart = cart; lastCartAt = Date.now();
        decorate(cart);
        updateCartBadge(cart); // corecteaza bulina si dupa ce tema o rescrie cu totalul (inclusiv taxe)
      }).catch(function () {});
    }, 250);
  }

  onReady(function () {
    scheduleDecorate();
    try {
      new MutationObserver(scheduleDecorate).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  });
})();
